

import React, { memo, useCallback } from 'react';
import FiltersGroupContainer from './FiltersGroupContainer';
import DatePicker from '../../DatePicker';


















const DateFiltersGroup = ({
  label: groupLabel,
  openedByDefault,
  minWidth,
  isCollapsible,
  selectedValues,
  filterFacets,
  onChange
}) => {
  // To not break current advanced filter functionality
  // Pass options to first filter facet
  const datePickerProps = filterFacets && filterFacets[0] || {};
  const startDate = selectedValues ? selectedValues[0] : '';

  const onStartDateChange = useCallback((date) => {
    onChange(date ? [date.utc(true).toISOString()] : []);
  }, [onChange]);

  const { label, disabled, id = groupLabel, placeholder = 'Select date' } = datePickerProps;

  return (
    <FiltersGroupContainer
      className="date-filter-group"
      label={groupLabel}
      isCollapsible={isCollapsible}
      openedByDefault={openedByDefault}
      minWidth={minWidth}>

      <DatePicker
        startLabel={label}
        startPlaceholder={placeholder}
        onSelectStartDate={onStartDateChange}
        startDate={startDate}
        id={id}
        openDown
        disabled={disabled}
        enablePastDays />

    </FiltersGroupContainer>);

};

export default memo(DateFiltersGroup);